module.exports = __webpack_public_path__ + "static/images/solution.c649d0d452dd0f322885e2bdb98ab8ec.png";